import { BaseModel } from "@blue-chip/core";

export default class FeeSummary extends BaseModel {}
